module.exports = __webpack_public_path__ + "static/img/box-1.90051a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box-1.png
// module id = VicA
// module chunks = 1